export enum ConvoOperation {
    Saving = 'saving',
    Publishing = 'publishing',
}
